<template>
  <div class="compressed-content">
    <h3 class="page-question">Have you EVER experienced symptoms or treatment for blockages in your heart arteries?<br /><i>(Check all that apply)</i></h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.arteryBlockage">
      <b-form-checkbox v-model="survey.arteryBlockages.arteryBlockage.hadNoSymptoms"
                       @change="onNoSymptomSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.arteryBlockage.hadAngina"
                       @change="onAnginaSelected">
        Chest pain with activity (angina)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.arteryBlockage.hadUnstableAngina"
                       @change="onUnstableAnginaSelected">
        Chest pain with minimal or no activity (unstable angina)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.arteryBlockage.hadClaudation"
                       @change="onClaudationSelected">
        Leg pain (claudication)
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      arteryBlockage: {
        anyOptionRequired: anyOptionRequired((value) => value.hadNoSymptoms || value.hadAngina
          || value.hadUnstableAngina || value.hadClaudation)
      }
    },

    computed: {
      ...mapState(["survey"]),

      arteryBlockage() { return this.survey.arteryBlockages.arteryBlockage; }
    },

    methods: {
      onNoSymptomSelected(value) {
        this.setOptions(value, false, false, false);
      },

      onAnginaSelected(value) {
        this.setOptions(false, value, this.arteryBlockage.hadUnstableAngina, this.arteryBlockage.hadClaudation);
      },

      onUnstableAnginaSelected(value) {
        this.setOptions(false, this.arteryBlockage.hadAngina, value, this.arteryBlockage.hadClaudation);
      },

      onClaudationSelected(value) {
        this.setOptions(false, this.arteryBlockage.hadAngina, this.arteryBlockage.hadUnstableAngina, value);
      },

      setOptions(hadNoSymptoms, hadAngina, hadUnstableAngina, hadClaudation) {
        this.survey.arteryBlockages.arteryBlockage.hadNoSymptoms = hadNoSymptoms;
        this.survey.arteryBlockages.arteryBlockage.hadAngina = hadAngina;
        this.survey.arteryBlockages.arteryBlockage.hadUnstableAngina = hadUnstableAngina;
        this.survey.arteryBlockages.arteryBlockage.hadClaudation = hadClaudation;
      }
    }
  };
</script>